import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import useMedia from '@/hooks/useMedia'

// Components
import Icon from '@/assets/icons'

// Libs
import { goToCalendarPage } from '@/methods/goToPage'
import { resetCalendarData } from '@/redux/reducers/calendar'
import { handleGtmClickLiveCalendar } from '@/methods/handleGtmEvent'

// Constants
import { GTM_LOCATION } from '@/constants/gtmEvent'
import { GtmClickLiveCalendarClickText } from '@/constants/gtmEvent'

// Styles
import styles from './style.module.scss'
import { useRouter } from 'next/router'
import { useAppDispatch } from '@/redux/hooks'
const cx = classnames.bind(styles)

interface IProductScheduleButtonProps {
  className?: string
}

const ProductScheduleButton = ({ className }: IProductScheduleButtonProps) => {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { isDesktop } = useMedia()

  const handleSendTrackEvent = () => {
    handleGtmClickLiveCalendar({
      location: GTM_LOCATION.LIVE,
      clickText: t(GtmClickLiveCalendarClickText.CALENDAR),
    })
  }

  const handleClick = () => {
    handleSendTrackEvent()
    dispatch(resetCalendarData({}))
    goToCalendarPage(router)
  }
  return (
    <button className={cx('product-schedule-button', className)} onClick={handleClick}>
      <div className={cx('product-schedule-button-icon')}>
        <Icon.Calendar />
      </div>
      {isDesktop && <div className={cx('product-schedule-button-text')}>{t('LiveStreamingPreview_Title')}</div>}
    </button>
  )
}

export default ProductScheduleButton
